import React from "react";
import {
  HiddenRadioInput,
  RadioCircle,
  RadioLabel,
  RadioLabelContent,
  TickRadioWrapper,
} from "./TickRadioComp.style";

interface TickRadioCompProps {
  children?: React.ReactNode;
  isSelected: boolean;
  onClick: () => void;
  inputId: string;
}

const TickRadioComp: React.FC<TickRadioCompProps> = ({
  children,
  isSelected,
  onClick,
  inputId,
}) => {
  return (
    <TickRadioWrapper onClick={onClick} isSelected={isSelected}>
      <HiddenRadioInput
        type="radio"
        id={inputId}
        checked={isSelected}
        onChange={onClick}
      />
      <RadioLabel htmlFor={inputId}>
        <RadioCircle isSelected={isSelected} />
        <RadioLabelContent>{children}</RadioLabelContent>
      </RadioLabel>
    </TickRadioWrapper>
  );
};

export default TickRadioComp;
